
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vejpongosot120years",
      function () {
        return require("private-next-pages/vejpongosot120years/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vejpongosot120years"])
      });
    }
  